import React from 'react';
import { ImageUpload } from '../../components/forms/ImageUpload';
import { useSettings } from './useSettings';
import { useI18n } from '../../i18n/I18nContext';
import {
  SectionDivider, ColorPicker,
  Toast, PageHeader, PageFooter, LoadingSpinner,
} from './SettingWidgets';

export function AppearancePage() {
  const { t } = useI18n();
  const {
    form, set, loading, saving, toast,
    pendingCover, setPendingCover,
    pendingLogo, setPendingLogo,
    handleSave, handleDiscard,
  } = useSettings();

  if (loading) return <LoadingSpinner />;

  return (
    <div className="mx-auto max-w-4xl space-y-0">
      <Toast toast={toast} />

      <PageHeader
        title={t('appearance.title')}
        description={t('appearance.subtitle')}
        saving={saving}
        onSave={handleSave}
      />

      {/* Images */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900">
        <div className="border-b border-slate-100 px-4 py-4 sm:px-6 dark:border-slate-800">
          <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">{t('appearance.sections.brandImages.title')}</h2>
          <p className="text-xs text-slate-500 dark:text-slate-400">{t('appearance.sections.brandImages.subtitle')}</p>
        </div>
        <div className="space-y-5 px-4 py-5 sm:px-6">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <ImageUpload
              label={t('appearance.fields.coverImage')}
              currentUrl={form.coverImageUrl}
              pendingFile={pendingCover}
              onSelect={setPendingCover}
              onClear={() => set('coverImage', '')}
            />
            <ImageUpload
              label={t('appearance.fields.logo')}
              currentUrl={form.logoImageUrl}
              pendingFile={pendingLogo}
              onSelect={setPendingLogo}
              onClear={() => set('logoImage', '')}
            />
          </div>
        </div>
      </div>

      <SectionDivider title={t('appearance.dividers.colors')} />

      {/* Brand Colors */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-900">
        <div className="border-b border-slate-100 px-4 py-4 sm:px-6 dark:border-slate-800">
          <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">{t('appearance.sections.brandColors.title')}</h2>
          <p className="text-xs text-slate-500 dark:text-slate-400">{t('appearance.sections.brandColors.subtitle')}</p>
        </div>
        <div className="flex flex-wrap gap-6 px-4 py-5 sm:gap-8 sm:px-6">
          <ColorPicker
            label={t('appearance.fields.themeColor')}
            value={form.themeColor}
            onChange={(v) => set('themeColor', v)}
          />
          <ColorPicker
            label={t('appearance.fields.buttonColor')}
            value={form.buttonColor}
            onChange={(v) => set('buttonColor', v)}
          />
          <ColorPicker
            label={t('appearance.fields.serviceColor')}
            value={form.serviceColor}
            onChange={(v) => set('serviceColor', v)}
          />
        </div>
      </div>

      <PageFooter saving={saving} onSave={handleSave} onDiscard={handleDiscard} />
    </div>
  );
}
